import React from 'react';
import PropTypes from 'prop-types';

const Spinner = ({ neutral }) => {
  const classList = ['spinner'];

  if (neutral) {
    classList.push('spinner--neutral');
  }

  return <div className={classList.join(' ')} />;
};

Spinner.propTypes = {
  neutral: PropTypes.bool
};

Spinner.defaultProps = {
  neutral: false
};

export default Spinner;



// WEBPACK FOOTER //
// ./src/components/Common/Spinner/Spinner.js